import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { queryOrThrow } from "@rootreeweb/js-lib";
import App from "./app/App";
const container = queryOrThrow("#rt-impact-report-container");
createRoot(container).render(_jsx(App, {}));
